import React, { useEffect, useState } from 'react';

interface Props {
  validFromUtc?: string | null;
  validToUtc?: string | null;
  status?: string;
}

function formatSpan(ms: number) {
  const minutes = Math.max(0, Math.round(ms / 60000));
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours}h ${rest}m` : `${hours}h`;
}

/** Small status chip: "Starts in 1h", "Expires in 42m", or "Expired". Updates every 30 s. */
const ValidityBadge: React.FC<Props> = ({ validFromUtc, validToUtc, status }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 30000);
    return () => window.clearInterval(timer);
  }, []);

  if (!validToUtc) return null;
  const end = new Date(validToUtc).getTime();
  const start = validFromUtc ? new Date(validFromUtc).getTime() : null;
  if (Number.isNaN(end)) return null;

  let label: string;
  let tone: string;
  if (now >= end || status === 'archived') {
    label = 'Expired';
    tone = 'validity-expired';
  } else if (start && now < start) {
    label = `Starts in ${formatSpan(start - now)}`;
    tone = 'validity-pending';
  } else {
    label = `Expires in ${formatSpan(end - now)}`;
    tone = end - now <= 30 * 60000 ? 'validity-ending' : 'validity-active';
  }

  return <span className={`chip chip-static validity-badge ${tone}`} title={new Date(end).toUTCString()}>{label}</span>;
};

export default ValidityBadge;
